import { apiService } from "./index";

const shareService = {
  shareResource(data) {
    return apiService.post("/share/resource", data);
  },

  shareResourceList(data) {
    return apiService.post("/share/resource_list", data);
  },

  shareCart(data) {
    // Convert agencies array to indexed hash for Rails strong parameters compatibility
    const payload = { ...data };
    if (Array.isArray(payload.agencies)) {
      const agenciesHash = {};
      payload.agencies.forEach((item, i) => { agenciesHash[i] = item; });
      payload.agencies = agenciesHash;
    }
    return apiService.post("/share/cart", payload);
  },
};

export { shareService };
